import { AuthState } from '../auth.model';

export const initialState: AuthState = {};
